import { render, staticRenderFns } from "./AddPurchasesOrderComponent.vue?vue&type=template&id=44426e3e"
import script from "./AddPurchasesOrderComponent.vue?vue&type=script&lang=js"
export * from "./AddPurchasesOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports